<script lang='ts'>
import { defineComponent } from '@vue/composition-api';

const TagSlashIcon = defineComponent({
    name: 'TagSlashIcon',
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
});

export default TagSlashIcon;
</script>

<template>
  <svg
    width="448"
    height="512"
    viewBox="0 0 448 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M32 229.5V80C32 71.2 39.2 64 48 64H197.5C206 64 214.1 67.4 220.1 73.4L396.1 249.4C408.6 261.9 408.6 282.2 396.1 294.7L262.6 428.1C250.1 440.6 229.8 440.6 217.3 428.1L41.3 252.1C35.3 246.1 31.9 238 31.9 229.5H32ZM0 229.5C0 246.5 6.7 262.8 18.7 274.8L194.7 450.8C219.7 475.8 260.2 475.8 285.2 450.8L418.7 317.3C443.7 292.3 443.7 251.8 418.7 226.8L242.7 50.8C230.7 38.8 214.4 32.1 197.4 32.1H48C21.5 32 0 53.5 0 80V229.5ZM112 168C118.365 168 124.47 165.471 128.971 160.971C133.471 156.47 136 150.365 136 144C136 137.635 133.471 131.53 128.971 127.029C124.47 122.529 118.365 120 112 120C105.635 120 99.5303 122.529 95.0294 127.029C90.5286 131.53 88 137.635 88 144C88 150.365 90.5286 156.47 95.0294 160.971C99.5303 165.471 105.635 168 112 168Z" fill="currentColor" />
    <line
      x1="388.909"
      y1="74.4264"
      x2="42.4269"
      y2="420.909"
      stroke="currentColor"
      stroke-width="40"
      stroke-linecap="round"
    />
  </svg>
</template>

<style lang='scss' scoped></style>